import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-agreements',
  templateUrl: './terms-agreements.component.html',
  styleUrls: ['./terms-agreements.component.scss']
})
export class TermsAgreementsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
